/** Angular */
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
/** Functions */
import { bydAppInitializerFn } from './functions/byd-app-initializer';
/** Services */
import { BydRuntimeService } from './services/byd-runtime.service';
/** Modules */
import { BYD_RUNTIME_INJECTION_TOKEN } from './configs/byd-api-injection-token';
import { BydRuntimeModuleInterface } from './interfaces/byd-runtime-module-interface';

/**
 * The beyond environment runtime module.
 *
 * @see https://github.com/sxd-platform/byd-front-libs/blob/master/projects/byd-lib-runtime/README.md
 * @property forRoot
 * @module BydRuntimeModule
 */
@NgModule({
  imports: [HttpClientModule],
  providers: [
    BydRuntimeService,
    {
      provide: APP_INITIALIZER,
      useFactory: bydAppInitializerFn,
      deps: [BydRuntimeService],
      multi: true,
    },
  ],
})
export class BydRuntimeModule {
  /**
   * Use this method in the root module to provide the BydCoreService.
   *
   * @param bydRuntime the provider value
   *
   * Get environment from specific location
   * @example BydCoreServiceModule.forRoot({
   *            url: '/folder/environments/environment.json'
   *      }),
   * @default location file '/assets/environments/environment.json'
   * @example BydCoreServiceModule.forRoot()
   * @returns ModuleWithProviders
   */
  static forRoot(bydRuntime?: BydRuntimeModuleInterface): ModuleWithProviders<BydRuntimeModule> {
    return {
      ngModule: BydRuntimeModule,
      providers: [
        BydRuntimeService,
        {
          provide: BYD_RUNTIME_INJECTION_TOKEN,
          useValue: bydRuntime,
        },
      ],
    };
  }
}
